import React, { useState, useEffect, useCallback } from 'react';
import {getServerEndPoint} from "../webEndPoint";
import SystemInfoLayout from "./systemInfosLayout";
import SimpleBackdrop from "../background";
// Note: This component uses Tailwind CSS for styling, providing a clean,
// responsive look similar to Material UI components.

// --- 1. Define Initial State ---

import config from "../../config/config";

const initialStats = {
    applicationVersion: 'Loading...',
    availableProcessors: 0,
    architecture: 'Loading...',
    processor : 'Loading...',
    os : 'Loading...',
    jvmUptimeSeconds: 0,
    totalMegabytesReceivedSinceBoot: 0,
    totalMegabytesTransmittedSinceBoot: 0,
    networkRateNotes: '',
    applicationName: 'Loading...',
    machineCurrentTime: 'Loading...',
    downloadRateMBs: 0,
    uploadRateMBs: 0,
};

const API_ENDPOINT = "infos/user-system";


// --- 2. Main React Component ---

export const SystemInfos = () => {
    // Initial state setup (no explicit types used)
    const [stats, setStats] = useState(initialStats);
    const [isLoading, setIsLoading] = useState(true);
    const [prevStats, setPrevStats] = useState(null);
    const [lastFetchTime, setLastFetchTime] = useState(0);
    const [, setError] = useState(null);

    // Fetch and calculate logic wrapped in a useCallback hook
    const fetchData = useCallback(async () => {
        try {
            const uri = getServerEndPoint() + API_ENDPOINT
            const response = await fetch(uri);
            if (!response.ok) {
                console.log(`HTTP error! status: ${response.status}`);
            }

            // Raw stats are inferred as an object
            const currentRawStats = await response.json();
            const currentFetchTime = Date.now();
            let newRates = {};

            if (prevStats && lastFetchTime) {
                const timeDeltaSeconds = (currentFetchTime - lastFetchTime) / 1000;

                // Calculate Download Rate (MB/sec)
                const receivedDeltaMB = currentRawStats.totalMegabytesReceivedSinceBoot - prevStats.totalMegabytesReceivedSinceBoot;
                newRates.downloadRateMBs = receivedDeltaMB > 0
                    ? receivedDeltaMB / timeDeltaSeconds
                    : 0;

                // Calculate Upload Rate (MB/sec)
                const transmittedDeltaMB = currentRawStats.totalMegabytesTransmittedSinceBoot - prevStats.totalMegabytesTransmittedSinceBoot;
                newRates.uploadRateMBs = transmittedDeltaMB > 0
                    ? transmittedDeltaMB / timeDeltaSeconds
                    : 0;

                setStats(prev => ({
                    ...prev,
                    ...currentRawStats,
                    ...newRates,
                }));

            } else {
                // Initial fetch, cannot calculate rate yet
                setStats(prev => ({
                    ...prev,
                    ...currentRawStats,
                    downloadRateMBs: 0,
                    uploadRateMBs: 0,
                }));
            }

            // Store current stats and time for the next calculation
            setPrevStats(currentRawStats);
            setLastFetchTime(currentFetchTime);
            setIsLoading(false);
            setError(null);

        } catch (err) {
            console.error("Failed to fetch system stats:", err);
        }
    }, [prevStats, lastFetchTime]);

    // Set up the polling effect
    useEffect(() => {
        // Fetch immediately on mount
        fetchData();

    }, []);


    if (isLoading) {
        return  <div style={{top :0, background:"black", height: "100vh", width: "100vw", display: "flex", padding:60, flexDirection:"column", justifyContent:"center" }}>
            <SimpleBackdrop open={true}></SimpleBackdrop>
        </div>
    }

    return (
        <SystemInfoLayout systemData={stats} serverName={config.licence}></SystemInfoLayout>
    )
};
